<m-expansion-panel [id]="'dividasRegularizadas-parceiros'" [title]="'Dívidas regularizadas em Parceiros ('+dividasRegularizadasParceiros.resultados.length+')'" [active]="larguraEhSuperiorMin">
  <div *ngIf="dividasRegularizadasParceiros.resultados.length > 0" class="table-responsive" id="div-table-dividasRegularizadas-parceiros">
    <table id="id-table-dividasRegularizadas-parceiros" class="table table-sm table-striped table-borderless" aria-label="Tabela de dívidas regularizadas" style="font-size: smaller;">
      <thead>

      <tr>
        <th scope="col">Empresa</th>
        <th scope="col">CNPJ</th>
        <th scope="col">Contrato</th>
        <th scope="col">Data da ocorrência</th>
        <th scope="col">Data da inclusão</th>
        <th scope="col">Data da baixa</th>
        <th scope="col">Valor</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let divida of dividasRegularizadasParceiros.resultados; index as i">
          <td>{{ divida.empresa | naoinformado }}</td>
          <td>{{ divida.cnpj | naoinformado }}</td>
          <td>{{ divida.contrato | naoinformado }}</td>
          <td>{{ divida.dataOcorrencia | naoinformado }}</td>
          <td>{{ divida.dataInclusao | naoinformado }}</td>
          <td>{{ divida.dataBaixa | naoinformado }}</td>
          <td>{{ divida.valor | moedaReal }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-dividasRegularizadas-parceiros-falha" *ngIf="listaServicoFalha.includes('bloco-dividas-regularizadas-parceiros') || dividasRegularizadasParceiros.resultados.length == 0">
    {{dividasRegularizadasParceiros.falhaServico.message}}
  </div>
  <app-alert [id]="'dividasRegularizadas-parceiros-mensagem'" [tipo]="'info'" >
    A Serasa Experian e o SPC Brasil são entidades distintas, autônomas, com bancos de dados próprios e, portanto, dotadas de administração própria.
  </app-alert>
</m-expansion-panel>
